import type { AdminBroadcast, LiveQuestion, LiveQuestionStatus, SpeakerOption } from "@/types";

import { BaseApi } from "./base.api";

export interface SpeakerInput {
  userId: string;
  roleLabel?: string;
}

export interface SaveBroadcastPayload {
  title: string;
  description: string;
  /** ISO 8601. */
  scheduledAt: string;
  /** Berilmasa sarlavhadan yasaladi. */
  slug?: string;
  industryId?: string | null;
  watchUrl?: string | null;
  speakers?: SpeakerInput[];
}

/**
 * Efirlarni boshqarish (ADR 0023).
 *
 * Bitta ruxsat — `live.manage`: efirni yaratgan odam uni boshlaydi
 * ham, savollarni ham o'sha efir davomida o'zi moderatsiya qiladi.
 */
class AdminLiveApi extends BaseApi {
  list() {
    return this.request<AdminBroadcast[]>("/admin/live");
  }

  /** Spiker bo'la oladiganlar — faqat faol mezbonlar. */
  speakers() {
    return this.request<SpeakerOption[]>("/admin/live/speakers");
  }

  create(payload: SaveBroadcastPayload) {
    return this.request<AdminBroadcast>("/admin/live", { method: "POST", body: payload });
  }

  update(id: string, payload: SaveBroadcastPayload) {
    return this.request<AdminBroadcast>(`/admin/live/${id}`, { method: "PUT", body: payload });
  }

  /** E'lon qilish yoki bekor qilish. */
  setStatus(id: string, status: "scheduled" | "canceled") {
    return this.request<AdminBroadcast>(`/admin/live/${id}/status`, {
      method: "POST",
      body: { status },
    });
  }

  /**
   * Efirni boshlaydi va XABAR yuboradi.
   *
   * `rtmpUrls` bo'sh bo'lishi mumkin: efirni tashqi dastur (OBS)
   * uzatayotgan bo'lsa, LiveKit Egress kerak emas.
   */
  start(id: string, rtmpUrls: string[]) {
    return this.request<AdminBroadcast>(`/admin/live/${id}/start`, {
      method: "POST",
      body: { rtmpUrls },
    });
  }

  stop(id: string) {
    return this.request<AdminBroadcast>(`/admin/live/${id}/stop`, { method: "POST" });
  }

  /** Savollar — yashirilganlari bilan birga. */
  questions(id: string) {
    return this.request<LiveQuestion[]>(`/admin/live/${id}/questions`);
  }

  decideQuestion(questionId: string, status: LiveQuestionStatus) {
    return this.request<LiveQuestion>(`/admin/live/questions/${questionId}`, {
      method: "POST",
      body: { status },
    });
  }
}

export const adminLiveApi = new AdminLiveApi();
